import React, { useState } from "react";
import { useParams } from "react-router-dom";
import baseUrl from "../../../../../../../../api/baseUrl";
import getDecryptedToken from "../../../../../../../../api/getDecryptedToken";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import AddSubTreatmentModel from "./AddSubTreatmentModel";
import AllSubTreatmentTr from "./AllSubTreatmentTr";
import { insertBreaks } from "../../../../../../../../utils/functions/resize";


const user: string | undefined = getDecryptedToken("userName");
function AllMainTreatmentTr({
  item,
  onClick,
  refresh,
  handleAddSubTreatmentModal,
}: any) {
  const dateNow = new Date();
  const { ID } = useParams();

  const [status, setstatus] = useState(item?.status);

  const handleSelect = (e: any) => {
    if (item?._id) {
      setstatus(e.target.value);
      baseUrl
        .post(
          "treatment/add-TreatmentStatus",
          { status: e.target.value },
          {
            headers: {
              treatmentid: ID,
              treatmentsid: item._id,
            },
          }
        )
        .then((response) => {
          refresh();
        })
        .catch((error) => {
          console.log(error);
        });
      
    }
  };
  const handleSelectClick = () => {
    if (item?._id === undefined) {
      refresh();
    }
  };

  // const now = new Date();
  // const offset = now.getTimezoneOffset(); // in minutes
  // const hours = Math.floor(Math.abs(offset) / 60);
  // const minutes = Math.abs(offset) % 60;
  // const gmtSign = offset <= 0 ? '+' : '-';
  // console.log(`GMT${gmtSign}${hours}:${minutes < 10 ? '0' + minutes : minutes}`);

  return (
    <>
      <tr>
        <td data-label="Date">
          {new Date(item?.createdAt)
            ? new Date(item?.createdAt).toISOString()?.split("T")[0] +
              "/" +
              new Date(item?.createdAt)
                .toISOString()
                ?.split("T")[1]
                ?.slice(0, 5)
            : new Date(dateNow).toISOString()}
        </td>
        <td data-label="Treatment">
          {item?.treatment}
          {item?.type ? "-" + item?.type : ""}
          {item?.subtype ? "-" + item?.subtype : ""}
        </td>
        <td data-label="surface">{item?.surface}</td>
        <td data-label="tooth No">{item?.toothNo}</td>
        <td data-label="Quantity">{item?.quantity}</td>
        <td data-label="price">{item?.price}</td>
        <td data-label="Status" onClick={handleSelectClick}>
          <select value={status} onChange={handleSelect}>
            {!item?.paid && <option value="planned">Planned</option>}
            <option value="ongoing">Ongoing</option>
            <option value="Complete">Complete</option>
          </select>
        </td>
        <td data-label="Dentist">
          {item?.didBy
            ? item?.didBy?.firstName +
              " " +
              (item?.didBy?.lastName != null ? item?.didBy?.lastName : "")
            : user}
        </td>
        <td data-label="note">{insertBreaks(item?.note)}</td>
        <td data-label="action">
          <abbr title="add treatment Record">
            <button
              onClick={() => handleAddSubTreatmentModal(item?._id)}
              className={"addto"} 
            >
              <AddCircleIcon />
            </button>
          </abbr>
          {!item?.paid && (
            <button onClick={onClick} className={"delete"}>
              <DeleteOutlineIcon />
            </button>
          )}
        </td>
      </tr>
    </>
  );
}

export default AllMainTreatmentTr;
